import Vue from 'vue'
import { Input, Tooltip } from 'ant-design-vue'
Vue.use(Input)
Vue.use(Tooltip)

export default Vue.extend({
  template: `
    <div class="a-gcell">
    <input type="radio" name="selected" @change="handleChange()">
    </div>
    `,
  data() {
    return {
    }
  },
  methods: {
    handleChange() {
      this.params.node.setSelected(!this.params.node.selected)
    },
  },
})
